<template
  ><v-card elevation="0">
    <v-card-title class="font-weight-regular">
      {{ $t('RELATED_COMPANIES.ITEMS') }}
      <v-spacer />
      <v-btn dark color="indigo" @click="create">
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }} {{ $t('RELATED_COMPANIES.ITEM') }}
      </v-btn>
    </v-card-title>

    <v-card-text>
      <related-list
        v-bind="relatedCompaniesListData"
        :options.sync="options"
        @show="show"
      />
    </v-card-text>
    <v-dialog
      v-if="dialog"
      v-model="dialog"
      persistent
      width="unset"
      max-width="800"
    >
      <component
        :is="component.name"
        v-bind="component.data"
        :errors="errors.getAll()"
        @create="createRelation"
        @update="updateRelation"
        @remove="removeRelation"
        @cancel="cancelDialog"
        @update-prop="clearErrorByName($event)"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import RelatedList from '@/modules/relations/components/RelatedList';
import DataOptions from '@/modules/_global/classes/DataOptions';
import BuildingComplexRelatedCompaniesService from '@/services/relations/building-complex-related-companies.service';
import errors from '@/modules/_global/mixins/errors';

export default {
  name: 'RelatedCompanies',

  components: {
    RelatedList,
    CreateRelatedCompany: () =>
      import('@/modules/relations/components/CreateRelatedCompany'),
    ShowRelatedCompany: () =>
      import('@/modules/relations/components/ShowRelatedCompany')
  },

  mixins: [errors],

  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['priority'],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false
      },
      relatedCompaniesListData: {
        relations: [],
        meta: {}
      },
      dialog: false,
      component: null
    };
  },

  computed: {
    preparedOptions() {
      return DataOptions.createFromObject(this.options).toBackendFormat();
    }
  },

  watch: {
    options: {
      deep: true,
      immediate: true,
      handler() {
        this.refreshData();
      }
    }
  },

  methods: {
    getDataRelatedCompanies() {
      BuildingComplexRelatedCompaniesService.getList(
        this.value.id,
        this.preparedOptions
      ).then(({ data }) => {
        this.relatedCompaniesListData.relations = data.data;
        this.relatedCompaniesListData.meta = data.meta;
      });
    },

    create() {
      this.dialog = true;
      this.component = {
        name: 'CreateRelatedCompany',
        data: {
          name: this.value.name
        }
      };
    },

    show(v) {
      BuildingComplexRelatedCompaniesService.getById(
        this.value.id,
        v.related_id
      )
        .then(({ data }) => {
          this.dialog = true;
          this.component = {
            name: 'ShowRelatedCompany',
            data: {
              name: this.value.name,
              value: { ...data }
            }
          };
        })
        .catch(console.error);
    },

    cancelDialog() {
      this.dialog = false;
      this.component = null;
    },

    cancelDialogAndRefresh() {
      this.refreshData();
      this.cancelDialog();
    },

    refreshData() {
      this.getDataRelatedCompanies();
    },

    createRelation(form) {
      BuildingComplexRelatedCompaniesService.create(this.value.id, form)
        .then(({ data }) => {
          this.cancelDialogAndRefresh();
        })
        .catch(this.handleErrors);
    },

    updateRelation(form) {
      BuildingComplexRelatedCompaniesService.update(this.value.id, form)
        .then(({ data }) => {
          this.cancelDialogAndRefresh();
        })
        .catch(this.handleErrors);
    },

    removeRelation() {
      BuildingComplexRelatedCompaniesService.remove(
        this.value.id,
        this.component.data.value.related_id
      )
        .then(({ data }) => {
          this.cancelDialogAndRefresh();
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
        })
        .catch(this.handleErrors);
    }
  }
};
</script>
